const units = [['years', ['год', 'года', 'лет']], ['months', ['месяц', 'месяца', 'месяцев']], ['days', ['день', 'дня', 'дней']], ['hours', ['час', 'часа', 'часов']], ['minutes', ['минута', 'минуты', 'минут']]];
function relativeTime(moment, value, now, kind = 'date', full = false) {
    if (!value || !moment(value).isValid()) return '';
    const target = moment(value), current = moment(now);
    const past = target.isBefore(current);
    let cursor = (past ? target : current).clone();
    const end = past ? current : target, parts = [];
    units.forEach(([unit, forms], index) => {
        const count = end.diff(cursor, unit);
        if (count) { cursor.add(count, unit); const n = count % 100, d = count % 10; parts.push({index, text: count + ' ' + forms[n >= 11 && n <= 14 ? 2 : d === 1 ? 0 : d >= 2 && d <= 4 ? 1 : 2]}); }
    });
    // Граница точности зависит от масштаба, а не от числа ненулевых единиц:
    // годы → месяцы, месяцы → дни, дни → дни, часы/минуты → минуты.
    const lastUnit = parts.length ? [1, 2, 2, 4, 4][parts[0].index] : -1;
    const duration = parts.filter(part => full || part.index <= lastUnit).map(part => part.text).join(' ') || 'меньше минуты';
    if (kind === 'deadline') return (past ? 'Просрочена на ' : 'Осталось ') + duration;
    if (kind === 'item') return (past ? 'Просрочен на ' : 'Осталось ') + duration;
    if (kind === 'control') return past ? 'Контроль наступил ' + duration + ' назад' : 'Контроль через ' + duration;
    if (kind === 'repeat') return past ? 'Повтор наступил ' + duration + ' назад' : 'Следующий повтор через ' + duration;
    return past ? duration + ' назад' : 'Через ' + duration;
}
module.exports = {relativeTime};
